import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapsAPILoader } from '@agm/core';
import { LocationType } from '../graphql-client/graphql';

interface Location {
  latitude: number;
  longitude: number;
  address: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private locationTypeChangeSubject = new Subject<LocationType>();
  private locationChangeSubject = new Subject<Location>();
  private geocoderPromise: Promise<google.maps.Geocoder>;

  public locationType$ = this.locationTypeChangeSubject.asObservable();
  public location$ = this.locationChangeSubject.asObservable();

  constructor(private mapsAPILoader: MapsAPILoader) {
    this.geocoderPromise = new Promise(resolve => {
      this.mapsAPILoader.load().then(() => {
        resolve(new google.maps.Geocoder());
      });
    });
  }

  updateLocationType(locationType: LocationType) {
    console.log(`Location Type Updated: ${locationType}`);
    this.locationTypeChangeSubject.next(locationType);
  }

  updateLocation(location: Location) {
    console.log(`Location Updated: `, location);
    this.locationChangeSubject.next(location);
  }

  geocode(address: string): Promise<Location> {
    console.log(`Geocoding address: ${address}`);

    const geocodedLocationPromise = new Promise(resolve => {
      this.geocoderPromise.then(geocoder => {
        geocoder.geocode(
          {
            address: address,
            componentRestrictions: {
              country: 'US'
            }
          },
          results => {
            const place = results[0];
            const geocodedLocation = <Location>{
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng(),
              address: place.formatted_address
            };

            this.updateLocation(geocodedLocation);
            resolve(geocodedLocation);
          }
        );
      });
    });

    return <Promise<Location>>geocodedLocationPromise;
  }
}
